import {
    GET_LEADOM_WEB_JOBS_REQUEST, GET_LEADOM_WEB_JOBS_REQUEST_SUCCESS, GET_LEADOM_WEB_JOBS_REQUEST_FAILURE, SET_LEADOM_FILTER_WEB_JOBS,
} from '../constants/web_jobs.constants';

export const getWebJobsRequest = () => ({
    type: GET_LEADOM_WEB_JOBS_REQUEST,
});

export const getWebJobsRequestSuccess = payload => ({
    type: GET_LEADOM_WEB_JOBS_REQUEST_SUCCESS, payload,
});

export const setFilterWebJobs = searchText => ({
    type: SET_LEADOM_FILTER_WEB_JOBS,
    searchText,
});

export const getWebJobsRequestFailure = error => ({
    type: GET_LEADOM_WEB_JOBS_REQUEST_FAILURE, error,
});



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Lead-o-matic/redux/actions/get_web_jobs.actions.js